module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ULG2D/tc-custom/9781440520419.jpg?1730494028192",
      "alt": "This image is the cover for the book When Your Child Has . . . Autism, When Your Child Has A . . ."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("When Your Child Has . . . Autism, When Your Child Has A . . .\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hearing the words ôyour child has Autismö is more common than ever. But dealing with this news will never be easy. When the devastating diagnosis is made, millions of questions and concerns will flood parentsÆ brains. This book will answer panicked parentsÆ questions in clear and complete terms. Taking an in-depth look at the reality of the disability, its causes, and how to cope as a family, this professional yet personal primer will help parents get through those first oh-so-tough times after the diagnosis."), _c('br'), _c('br'), _vm._v(" Autism is a complex developmental disabilityùthere are no medical tests for diagnosing autism and there is no ôcure.ö Parents need an accessible resource to go to for help in a hurryùwhen they donÆt know where else to turn and what is going to happen next.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adele Jameson Tilton, Vincent Iannelli\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0